const stats = [
  { value: '24h', label: '全天候开播' },
  { value: '多端', label: '电脑/手机同步' },
  { value: '千万级', label: '活跃用户规模' },
  { value: '丰富', label: '娱乐玩法类型' },
];

export default function Platform() {
  return (
    <section id="platform" className="w-full py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
        <div>
          <span className="inline-flex items-center gap-2 text-primary-600 text-sm font-medium">
            <i className="ri-sound-module-line" aria-hidden="true"></i>
            平台介绍
          </span>
          <h2 className="mt-4 text-2xl md:text-4xl text-foreground-950 leading-snug">
            关于歪歪官方网站平台
          </h2>
          <p className="mt-5 text-foreground-700 leading-relaxed text-sm md:text-base">
            歪歪官方网站是集高清直播、语音连麦、游戏开黑、线上K歌与交友互动于一体的综合性娱乐平台。无论你身在何处，都能通过歪歪官方网站首页快速进入，在热门直播间、语音频道和话题圈子里找到属于自己的快乐角落。
          </p>
          <p className="mt-4 text-foreground-700 leading-relaxed text-sm md:text-base">
            平台以"随时随地，快乐开聊"为核心理念，覆盖才艺、游戏、音乐、交友、户外、情感等众多内容品类。通过歪歪官方网站登录后，你的关注、好友与观看记录可在多端同步，让娱乐体验无缝衔接。
          </p>

          <div className="mt-8 grid grid-cols-2 sm:grid-cols-4 gap-4">
            {stats.map((s) => (
              <div key={s.label} className="rounded-lg bg-background-100 border border-background-200 p-4 text-center">
                <p className="text-xl md:text-2xl font-heading text-primary-600">{s.value}</p>
                <p className="mt-1 text-xs text-foreground-600">{s.label}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="relative rounded-xl overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=cheerful%20young%20people%20enjoying%20live%20entertainment%20with%20smartphones%20and%20headphones%20together%2C%20warm%20coral%20and%20golden%20ambient%20lighting%2C%20cozy%20social%20scene%2C%20cinematic%20warm%20tone%20with%20soft%20bokeh%2C%20joyful%20and%20lively%20atmosphere%2C%20high%20detail&width=900&height=1100&seq=yy-platform-2026&orientation=portrait"
            alt="歪歪官方网站娱乐平台使用场景"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute bottom-4 left-4 right-4 rounded-lg bg-foreground-950/70 backdrop-blur-sm px-5 py-4 text-background-50">
            <p className="flex items-center gap-2 text-sm font-medium">
              <i className="ri-heart-fill text-accent-400" aria-hidden="true"></i>
              娱乐、陪伴与快乐，一站汇聚
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}